<template>
  <div>
    <vue-easy-lightbox
      :visible="showAsLightbox"
      :imgs="imgs"
      :index="currentPageIndex"
      @hide="onCloseLightbox"
      @on-index-change="onLightboxIndexChange"
    ></vue-easy-lightbox>
    <vue-slider v-model="sizeInPixels" :min="50" :max="1000" @change="sliderChange"></vue-slider>
    <div class="flex flex-wrap">
      <div
        v-for="(page, index) of pages"
        :key="index"
        class="p-4"
      >
        <img
          :src="getThumbnailUrl(page)"
          :style="{ width: sizeInPixels + 'px' }"
          class="border-gray-600 border-solid"
          :class="{
            'border-2': index === currentPageIndex
          }"
          @click="onImageSelected(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getThumbnailUrl } from '../utils/image'

const localStorageKey = 'scrapbook-share.finder-view.sizeInPixels'

export default {
  props: {
    pages: Array,
    currentPageIndex: Number,
    currentPageId: Number,
    onClickItem: Function,
  },
  computed: {
    imgs() {
      return this.pages.map(x => ({
        src: x.pictureUrl,
      }))
    },
  },
  data() {
    return {
      showAsLightbox: false,
      sizeInPixels: this.$localStorage.get(localStorageKey, 100),
    }
  },
  methods: {
    onLightboxIndexChange(from, to) {
      this.onClickItem(to)
    },
    onCloseLightbox() {
      this.showAsLightbox = false
    },
    onImageSelected(index) {
      this.onClickItem(index)
      this.showAsLightbox = true
    },
    keysListener(event) {
      if (event.code === 'Space') {
        event.preventDefault()
        this.showAsLightbox = !this.showAsLightbox
      }
    },
    sliderChange(value) {
      this.$localStorage.set(localStorageKey, value)
    },
    getThumbnailUrl(page) {
      return getThumbnailUrl(page)
    },
  },
  mounted() {
    window.addEventListener('keydown', this.keysListener)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keysListener)
  },
}
</script>
